import Vue from "vue";
const timezone = require("moment-timezone");

export function betterTime(sometime) {
	return timezone(sometime).tz(window.TIMEZONE).format("DD/MM, HH:mm");
}

export function betterTimeWithFormat(sometime, format) {
	return timezone(sometime).tz(window.TIMEZONE).format(format);
}

export function currency(number) {
	return window.CURRENCY + parseFloat(number).toLocaleString(window.LOCALE);
}

export function millisToMinutesAndSeconds(millis) {
	var minutes = Math.floor(millis / 60000);
	var seconds = ((millis % 60000) / 1000).toFixed(0);
	return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
}

export function truncate(somestring, length) {
	return (
		somestring.substring(0, Math.min(length, somestring.length)) +
		(somestring.length >= length ? "..." : "")
	);
}

export function seoText(text) {
	return text.split(" ").join("-").toLowerCase();
}

export function toTitleCase(str) {
	if (!str) return str;

	let parts = str.split(" ");
	let full = [];
	parts.forEach((part) => {
		if (part.length <= 2 && parts.length == 1)
			return full.push(part.toUpperCase());
		full.push(
			part.replace(/\w\S*|\/\*/g, function (txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			})
		);
	});
	return full.join(" ");
}

export function validatePhoneNumber(phone) {
	const regex = new RegExp(MOBILE_REGEX);
	return regex.test(phone);
}

export function formatPhoneNo(phone) {
	return phone.replace(/[^0-9]/g, '')
		.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

Vue.filter("time", betterTime);
Vue.filter("timeFormat", betterTimeWithFormat);
Vue.filter("currency", currency);
Vue.filter("truncate", truncate);
Vue.filter("millisToMinutesAndSeconds", millisToMinutesAndSeconds);
Vue.filter("toTitleCase", toTitleCase);
Vue.filter("seoText", seoText);
Vue.filter("formatPhoneNo", formatPhoneNo);
